<div class="compendium-allow-container">

    <div class="header">
        <div>{{title}}</div>
        <fi-button
          variant="tertiary"
          tone="neutral"
          size="lg"
          [iconOnly]="true"
          (click)="closeDialog()"
        >
          <mat-icon fiButtonIcon>close</mat-icon>
          <span fiTranslation="ALT_TEXT_DIALOG_CLOSE"></span>
        </fi-button>
    </div>

    <div class="main-container">
        <div class="horizontal-container">
            <fi-request-contacts [contactToDisplay]="contactToDisplay" [companyContacts]="companyContacts"></fi-request-contacts>

            <div class="form">

                <fi-alert tone="info">
                    <span fiTranslation="ACTION_START_RELATIONSHIP_MANAGEMENT_INFO_TEXT_COMPENDIUM_ACCESS"></span>
                </fi-alert>


                <div>
                    <div class="field-title"><span fiTranslation="ACTION_GENERAL_HEADLINE_REQUEST_NOTE2"></span></div>
                    <fi-editor
                      [noUploads]="true"
                      [placeholderTranslation]="'REQUEST_DETAIL_NOTE_PLACEHOLDER'"
                      (isLongDescription)="inValidNote = $event"
                      (textChanged)="note = $event">
                    </fi-editor>
                </div>
              </div>
        </div>

    </div>

    <div class="footer">
        <button (click)="submit()" [disabled]="!formIsValid">
            <img [src]="iconUrl" alt="Action icon">
            <span> {{title}} </span>
        </button>
    </div>
</div>
